export enum Constants {
    ACCESS_KEY = 'YTU3I9403RRE610',
    AUTH_ERROR_CODE_COOKIE = 'auth_error_code',
    BASE_PATH = 'base',
    CSRF_KEY = 'csrf_request_token',
    LOGIN_URL = 'login',
    NOTIFICATION_POLLING = 5000, // In Milliseconds
    PASSWORD_CHANGE_REQUIRED = 'PASSWORD_CHANGE_REQUIRED',
    PENDING_LOGIN_COOKIE = 'pending_login',
    PENDING_PLATFORM_COOKIE = 'pending_platform',
    REFRESH_KEY = 'YTU3I9403RRE630',
    SESSION_ID = 'sessionId',
    SYSTEM_BASE_PATH = 'system-base',
    USER_ID = 'userId',
    USER_STATUS_POLLING = 10000, // In Milliseconds
    VAPID_PUBLIC_KEY = 'public_vapid'
}
